import React from 'react'
import classNames from 'classnames'

import { LabelValue } from '~/components/common/labels/LabelValue'
import RhapHoverTooltip, {
  type RhapHoverTooltipProps,
} from '~/components/common/RhapHoverTooltip'
import Typography from '~/components/elements/Typography/Typography'

import { ClickableLabelSpan } from './ClickableLabelSpan'

import styles from './LabelValueWrapper.module.scss'

type TriggerProps = Parameters<RhapHoverTooltipProps['trigger']>[0]

interface LabelValueWrapperProps {
  boldValue?: boolean
  className?: string
  label: string
  onClick?: () => void
  secondaryText?: string | null
  tooltipText?: string
  useSecondaryTextStyle?: boolean
  value: string | React.ReactNode
}

export const LabelValueWrapper: React.FC<LabelValueWrapperProps> = ({
  boldValue = false,
  className,
  label,
  onClick,
  secondaryText,
  tooltipText,
  useSecondaryTextStyle = false,
  value,
}) => {
  const valueClassName = classNames(styles.value, {
    [styles.valueInProgress]: boldValue,
  })

  const secondaryClassName = classNames(styles.value, {
    [styles.secondaryValue]: useSecondaryTextStyle,
  })

  const fullValue = (
    <>
      <span className={styles.valueBlock}>{value}</span>
      {secondaryText?.trim() && (
        <span className={secondaryClassName}>{secondaryText}</span>
      )}
    </>
  )

  const renderTrigger = (triggerProps: TriggerProps) => (
    <LabelValue
      LabelComponent={ClickableLabelSpan}
      LabelProps={{
        ...triggerProps,
        className: styles.labelClickable,
        onClick,
      }}
      ValueComponent={Typography.ParagraphSm}
      ValueProps={{ className: valueClassName }}
      className={className}
      label={label}
      layout="vertical"
      value={secondaryText?.trim() ? fullValue : value}
    />
  )

  if (onClick) {
    return (
      <RhapHoverTooltip
        content={tooltipText}
        placement="top"
        trigger={renderTrigger}
      />
    )
  }

  return (
    <LabelValue
      LabelComponent={Typography.H3}
      LabelProps={{ className: styles.label }}
      ValueComponent={Typography.ParagraphSm}
      ValueProps={{ className: valueClassName }}
      className={className}
      label={label}
      layout="vertical"
      value={secondaryText?.trim() ? fullValue : value}
    />
  )
}
